<template>
  <div class="fluid-view-content-container">
    <!-- LOADING -->
    <div v-if="loading" class="fluid-view-content-container_loading-content">
      <font-awesome-icon
        class="loading-content__spinner"
        :icon="['fas', 'cog']"
        spin
      ></font-awesome-icon>
      Ładowanie...
    </div>
    <!-- LOADED -->
    <div v-else-if="offerElement" class="view-content">
      <div class="view-content__decoration">
        <v-img
          class="decoration__background-image"
          :src="offerElement.image ? offerElement.image.url : ''"
          width="100%"
          :height="
            $vuetify.breakpoint.xs
              ? $vuetify.breakpoint.width
              : $vuetify.breakpoint.height * (2 / 3)
          "
        ></v-img>
        <div class="decoration__header">
          <font-awesome-icon
            :class="
              $vuetify.breakpoint.xs
                ? 'header__icon header__icon--xs-size'
                : 'header__icon'
            "
            :icon="[offerElement.icon.prefix, offerElement.icon.name]"
          ></font-awesome-icon>
          <div
            :class="
              $vuetify.breakpoint.xs
                ? 'header__text header__text--xs-size'
                : 'header__text'
            "
          >
            {{ offerElement.title }}
          </div>
        </div>

        <v-btn
          fab
          class="decoration__navigation-button"
          @click="$router.go(-1)"
        >
          <font-awesome-icon :icon="['fas', 'arrow-left']"></font-awesome-icon>
        </v-btn>
      </div>
      <div class="view-content__texts v-container-bg--smokewhite">
        <v-container
          :class="$vuetify.breakpoint.xs ? 'v-col--no-horizontal-paddings' : ''"
        >
          <v-row>
            <v-col
              lg="12"
              :class="
                $vuetify.breakpoint.xs ? 'v-col--no-horizontal-paddings' : ''
              "
            >
              <div class="news-element__static-html tx-3 tx-b-500">
                W skrócie
              </div>
              <div
                class="news-element__content"
                v-html="offerElement.short"
              ></div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="view-content__texts v-container-bg--white">
        <v-container
          :class="$vuetify.breakpoint.xs ? 'v-col--no-horizontal-paddings' : ''"
        >
          <v-row>
            <v-col
              cols="12"
              sm="9"
              :class="
                $vuetify.breakpoint.xs ? 'v-col--no-horizontal-paddings' : ''
              "
            >
              <div class="news-element__static-html tx-3 tx-b-500">
                Opis oferty
              </div>
              <div
                class="news-element__content"
                v-html="offerElement.content"
              ></div>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              :class="
                $vuetify.breakpoint.xs ? 'v-col--no-horizontal-paddings' : ''
              "
            >
              <div
                :class="
                  $vuetify.breakpoint.xs
                    ? ' tx-3 tx-b-500 tx-regular-gray offer-element__static-html offer-element__static-html--no-top-margin'
                    : ' tx-3 tx-b-500 tx-regular-gray offer-element__static-html'
                "
              >
                Główne technologie
              </div>
              <div
                class="news-element__content"
                v-html="offerElement.technologies"
              ></div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <contact-component></contact-component>
    </div>
  </div>
</template>

<script>
import ContactComponent from "@/components/ContactComponent/ContactComponent";
import { OfferElement } from "@/models/offer-element.model";
import { FasIcon } from "@/models/fas-icon.model";
import websiteContents from "@/website-contents";

export default {
  name: "offer-element-view",
  data: function() {
    return {
      offerElement: null,
      loading: false
    };
  },
  watch: {
    $route: "getOfferElement"
  },
  mounted() {
    this.getOfferElement();
  },
  methods: {
    setIconsForFA() {
      this.offerElement.icon = new FasIcon(this.offerElement.iconName);
    },
    getOfferElement() {
      this.loading = true;
      this.loading = false; //this.$route.params.title
      this.offerElement = new OfferElement();
      this.offerElement = websiteContents.offerElements.find(
        o => o.title.toString()
            .toLowerCase()
            .replaceAll(" ", "-") === this.$route.params.title
      );
      this.setIconsForFA();

      scrollTo(0, 0);
    }
  },
  components: { ContactComponent }
};
</script>
<style lang="scss">
.news-element__content {
  margin-top: 19px;
  font-size: 16px;
  margin-bottom: 24px;
  color: #707070;
}

.news-element__static-html {
  margin-top: 24px;
  font-size: 18px;
  color: #707070;
}

.view-content__decoration {
  background-color: #19a7ab;
  position: relative;
  top: 0;
}

.decoration__header {
  height: 200px;
  width: 100%;
  position: absolute;
  top: calc(50% - (200px / 2));
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.header__text {
  font-family: "Oswald SemiBold", sans-serif;
  font-size: 60px;
  color: white;
  text-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
  padding: 12px;
  text-align: center;
}

.header__icon {
  font-size: 100px;
  color: white;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.2));
}

.decoration__navigation-button {
  position: absolute;
  top: calc(100% - (56px / 2));
  left: calc(50% - (56px / 2));

  * {
    font-size: calc(56px / 2);
    color: #707070;
  }
}

.v-container-bg--smokewhite {
  background-color: #e9e9e9;
  width: 100%;
}

.v-col--no-horizontal-paddings {
  padding-top: 0;
  padding-bottom: 0;
}

.news-element__static-html--no-top-margin {
  margin-top: 0;
}

.header__text--xs-size {
  font-family: "Oswald", sans-serif;
  font-weight: 400;
  font-size: 32px;
}

.header__icon--xs-size {
  font-size: 72px;
}
</style>
